import React, { useState } from "react";
import "../styles/Faqs.css";

const faqsData = [
  {
    question: "How do I register an account?",
    answer:
      "Click on the 'Sign Up' button, enter your mobile number, verify with OTP, and you are good to go."
  },
  {
    question: "Is it even legal?",
    answer:
      "Yes, Huntexlotto is totally legal. HuntexLotto is an intermediary Lottery Service, which buys lottery tickets on behalf of its users. When you play on our site, we will buy lottery tickets as instructed by you for the games you specify.. However, all terms and conditions from the National Lottery Authority to a player apply."
  },
  {
    question: "Is this safe?",
    answer:
      "Yes, it is totally safe. All players are required to provide their login credentials before they can access their account. This makes secure, such that a different person cannot play nor cash out any money on your behalf or without your knowledge."
  },
  {
    question: "Is my personal information secure?",
    answer:
      "Yes, we use encryption and follow industry security standards to protect your data."
  },
  {
    question: "What happens with my tickets?",
    answer:
      "Your physical ticket is stored in a secured vault which only a few core admin members of HuntexLotto have access to."
  },
   {
    question: "Do you have to be of a certain age to use HuntexLotto?",
    answer:
      "Yes, you have to be at least 18 years old and above as per National Lottery Authority Terms and Conditions."
  },
   {
    question: "How do I know HuntexLotto won’t just steal my ticket if I win?",
    answer:
      "HuntexLotto acts as a payment agent while ensuring the security of your ticket after it has been purchased on your behalf from an officially registered and licensed lottery retailer. When an order is placed it is sent to an NLA retailer who stakes on your behalf. Confirmation of your staked is displayed."
  },
   {
    question: "How will I know if I won?",
    answer:
      "When you happen to win, an email and push notification is sent to alert you on your win and you can check yourself by going to your Account and My tickets tab to view your winning games."
  },
   {
    question: "How are the prizes determined??",
    answer:
      "Prizes are determined by the National Lottery Authority. Players are privileged to their expected rewards as they input their amount per stake to enable them make informed decision."
   },

   {
    question: "My ticket won, but I haven’t been credited yet. How come?",
    answer:
      "Complete results are not published immediately by the National Lottery Authority. We may not allow cash out until that is done. You can also contact support for assistance."
  },

   {
    question: "Do  HuntexLotto take commissions from my win?",
    answer:
      "No HuntexLotto lotto does not take any commission from your wins. All wins are sent to you directlly."
  },
    {
    question: "Who am I purchasing my ticket from?",
    answer:
      "HuntexLotto acts as an intermediary between you and the registered LMC to buy tickets on your behalf."
  }
];

export default function Faqs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h1 className="faq-title">Frequently Asked Questions</h1>

      <div className="faq-list">
        {faqsData.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <div
              className="faq-question"
              onClick={() => toggleFaq(index)}
            >
              <h3>{faq.question}</h3>
              <span>{activeIndex === index ? "−" : "+"}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
